import React from 'react'
import {Paper,Grid, Typography,Stack} from '@mui/material'

const scrollBar = {
  '&::-webkit-scrollbar': {
    width: '0.4em'
  },
  '&::-webkit-scrollbar-track': {
    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.3)',
    borderRadius: 2
    
  },
  '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(0,0,0,.5)',
      
    }
}

const InnerPage = ({title,body}) => {
  return (
    <Paper  
    sx={{...scrollBar,backgroundColor:'secondary.light',justifyContent:'center', overflow:'auto',
    width: {xs:'400px',sm:'600px',md:'700px'},
     height:{xs:'420px',sm:'600px',md:'700px',}}}>
        <Grid container justifyContent='center' sx={{paddingY:3,paddingX:{xs:4,md:8}}}>
            <Grid item xs={12}>
            <Typography variant='h4' sx={{paddingBottom:2}} align='center'>{title}</Typography>

            <Stack>
            {body.map((text)=>(
                <Typography variant='h6' fontFamily='Assistant' color='black' align='justify' sx={{paddingBottom:2}}>
                    {text}
                </Typography>
            ))}
            </Stack>
            </Grid>
        </Grid>
     </Paper>
  )
}

export default InnerPage